import { Component, OnInit, Input, ElementRef, Inject, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { DropdrownDirective } from '../dropdown/dropdown.directive';
import { DropdownComponent } from '../dropdown/dropdown.interface';

// import { UsersState } from '../../../_model/user/user.reducer';
import { Router, NavigationStart, NavigationEnd } from '../../../../../node_modules/@angular/router';
import { DnDialogService } from '../../../_modules/dn-dialog/dn-dialog.service';
import { RechargeBoxService } from '../../../_service/recharge-box/recharge-box.service';
import { Subscription } from 'rxjs';
import { Utility } from '../../../_service/utility';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { UserService } from '../../../_service/user/user.service';
import { StorageService } from '../../../storageprovider';
import { RechargeService } from '../../../_service/recharge/recharge.service';

@Component({
  selector: 'app-dn-user-menu-item',
  templateUrl: './dn-user-menu-item.component.html',
  styleUrls: ['./dn-user-menu-item.component.scss']
})
export class DnUserMenuItemComponent implements OnInit, OnDestroy {
  subscriptions: Array<Subscription> = [];
  hasDropdown = false;
 // private unsb = null;
  user;

  @Input()
  item;

  @Input()
  narrow = false;

  @Input()
  position = {};


  expand = false;

  @ViewChild(DropdrownDirective, { static: true }) dropdownHost: DropdrownDirective;
  hasUnreadMessages = false;
  concatsHasUnreadMessage = [];
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private _elementRef: ElementRef,
    private _dialogService: DnDialogService,
    private _router: Router,
    private _rechargeBoxService: RechargeBoxService,
    private _rechargeService:RechargeService,
    private _userService: UserService,
    private socketFacade: SocketFacade,
    // private _utility: Utility,
    private _storage: StorageService
  ) {


  }

  notifyCaption = "";
  readState() {

  }
  period = 1;
  notifications: any = {};
  ngOnInit() {
    if (this.item.title === 'seprator') {
      return;
    }

    if ((this.item.icon == "iconVIP")) { /// VIP标签

      this.disableNotify = this._storage.GetCookie("discountread") == "1";
      this._rechargeService.productState$.subscribe(p => {
        if(!p.hasValue)
        {
          return;
        }
        this.showDiscount = p.state.discountInfo.length > 0;
        if (this.showDiscount) {
          setTimeout(()=> {
            // 延迟一下，等top-nav的this.user.rechargeWords赋值后再修改title;
            this.notifyCaption = this.item.title = p.state.discountInfo[0].short;
            this.period = p.state.discountInfo[0].notifyPeriod || 1;
            // console.log(p.discountInfo[0].notifyPeriod)
          }, 0);
        }
    
      })

    }
    else {
      this.subscriptions.push(
        this._userService.notificationState$.subscribe(p => this.notifications = p),
        this._userService.userState$.subscribe(user => this.user = user),
        this._router.events.subscribe((evt) => {
          if (evt instanceof NavigationStart) {
            this.expand = false;
          }

          if (evt instanceof NavigationEnd) {
            const url = evt.urlAfterRedirects.split('?')[0];
            if (url === '/user/messages/chat') {
              this.hasUnreadMessages = false;
              this.concatsHasUnreadMessage = [];
            }
          }

        }),
        this.socketFacade.hasNewMessages$.subscribe(r => this.hasUnreadMessages = r),
        this.socketFacade.concatsHasUnreadMessage$.subscribe(r => this.concatsHasUnreadMessage = r)

      );

    }

    if (this.item.dropdown) {
      this.loadComponent();
    }


  }
  showDiscount = false;
  loadComponent() {
    const dropdown = this.item.dropdown;
    if (dropdown !== null) {
      this.hasDropdown = true;
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dropdown.component);
      const viewContainerRef = this.dropdownHost.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      dropdown.data['position'] = this._elementRef.nativeElement.getBoundingClientRect();
      dropdown.data['rect'] = this.item.rect;
      (<DropdownComponent>componentRef.instance).data = dropdown.data;
    }
  }
  disableNotify = false;
  onMouseEnter() {
    this.expand = true;
  }

  onMouseLeave() {
    this.expand = false;
  }

  menuItemClicked(item) {
    //console.log(item)
    if (item.icon == 'iconVIP') {
      if (!this.disableNotify) ///第一次查看后，30天之后继续提醒
      {
        this.disableNotify = true;
        this._storage.SetCookie("discountread", 1, this.period);
      }
      this._rechargeBoxService.changeDisplayStatus(true);
      return;
    }

    //console.log(item,this.user)
    if (item.authentication && this.user.id == 0) {
      this._dialogService.open('login-required-dialog');
      return;
    }

    if (item.link) {
      this._router.navigate([item.link]);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    // if (this.unsb != null) this.unsb();
  }
}
